// src/hooks/useLogout.js
import { useState } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../services/firebase';
import { useAuthContext } from './useAuthContext';

export const useLogout = () => {
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const { dispatch } = useAuthContext();
  
  const logout = async () => {
    setError(null);
    setIsPending(true);

    try {
      // Sign the user out
      await signOut(auth);
      
      // Dispatch logout action
      dispatch({ type: 'LOGOUT' });
      
      setIsPending(false);
      setError(null);
    } 
    catch (err) {
      console.error('Logout error:', err.message);
      setError(err.message);
      setIsPending(false);
    }
  };

  return { logout, error, isPending };
};